export const Loader = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7.99984 4.00033V6.00033L10.6665 3.33366L7.99984 0.666992V2.66699C5.05317 2.66699 2.6665 5.05366 2.6665 8.00033C2.6665 9.04699 2.97317 10.0203 3.49317 10.8403L4.4665 9.86699C4.1665 9.31366 3.99984 8.67366 3.99984 8.00033C3.99984 5.79366 5.79317 4.00033 7.99984 4.00033ZM12.5065 5.16033L11.5332 6.13366C11.8265 6.69366 11.9998 7.32699 11.9998 8.00033C11.9998 10.207 10.2065 12.0003 7.99984 12.0003V10.0003L5.33317 12.667L7.99984 15.3337V13.3337C10.9465 13.3337 13.3332 10.947 13.3332 8.00033C13.3332 6.95366 13.0265 5.98033 12.5065 5.16033Z"
      fill="#3A5BC7"
    />
  </svg>
);
